import {
  customShadowlessElement,
  type CorrectComponentType,
  correctElementType,
} from "@brytdesigns/web-component-core/utils";
import { createEffect } from "solid-js";

type Props = {
  formState: "initial" | "submitting" | "success" | "error";
};

const Component: CorrectComponentType<Props> = (props, { element }) => {
  const initialContent = element
    .querySelector("[data-content]")
    ?.cloneNode(true);
  createEffect(() => {
    const state = props.formState;
    if (state === "initial") {
      const content = element.querySelector("[data-content]");
      if (!content || !initialContent) return;
      content.replaceWith(initialContent.cloneNode(true));
    } else if (state === "submitting") {
      const content = element.querySelector("[data-content]");
      if (!content) return;
      const template = element.querySelector<HTMLTemplateElement>(
        "[data-state='adding']",
      );
      if (!template) return;
      content.replaceChildren(...[template.content.cloneNode(true)]);
    } else if (state === "success") {
      const content = element.querySelector("[data-content]");
      if (!content) return;
      const template = element.querySelector<HTMLTemplateElement>(
        "[data-state='added']",
      );
      if (!template) return;
      content.replaceChildren(...[template.content.cloneNode(true)]);
    } else if (state === "error") {
      const content = element.querySelector("[data-content]");
      if (!content) return;
      const template = element.querySelector<HTMLTemplateElement>(
        "[data-state='error']",
      );
      if (!template) return;
      content.replaceChildren(...[template.content.cloneNode(true)]);
    }
  });
};

customShadowlessElement(
  "add-to-cart-action",
  {
    formState: "initial",
  },
  correctElementType(Component),
);
